import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ComboboxOptions } from '../../../visual-components/combobox/types';
import { InlineNotification } from '../../../visual-components/form-inline-notification/form-inline-notification';
import { RadioGroup } from '../../../visual-components/radio-group/radio-group';

type FormComboboxProps = {
  name: string;
  label: string;
  options: ComboboxOptions;
  rules?: { required: string };
  inlineNotification?: InlineNotification;
  helperMsg?: string;
  required?: boolean;
  disabled?: boolean;
};

export const FormRadioGroup: React.FC<FormComboboxProps> = ({
  name,
  label,
  options,
  helperMsg,
  rules,
  inlineNotification,
  required = false,
  disabled = false,
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => {
        const { value, onChange } = field;
        return (
          <RadioGroup
            disabled={disabled}
            helperMsg={helperMsg}
            inlineNotification={inlineNotification}
            label={label}
            mandatory={required}
            options={options}
            value={value}
            onChange={onChange}
          />
        );
      }}
    />
  );
};
